import { Flex, IconButton, Stack, useDisclosure } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { useAccount } from "wagmi";
import { Chevron, WatchlistFavoritesIcon } from "@looksrare/uikit";
import { formatAddress, isAddressEqual } from "@looksrare/utils";
import { Watchlist } from "types/graphql";
import { ButtonProps, Popover, Text } from "uikit";
import { WatchlistName } from "views/watchlists/components/WatchlistName";

interface WatchlistSelectorPopoverProps extends ButtonProps {
  watchlists: Watchlist[];
  setSelectedWatchlist: (w: Watchlist) => void;
}
export const WatchlistSelectorPopover = ({
  watchlists,
  setSelectedWatchlist,
  ...props
}: WatchlistSelectorPopoverProps) => {
  const { address } = useAccount();
  const { t } = useTranslation();
  const { onClose, onToggle, isOpen } = useDisclosure();

  return (
    <Popover
      trigger="click"
      isOpen={isOpen}
      onClose={onClose}
      label={
        <Stack p={4} w="286px" bg="ui-bg" spacing={0}>
          {watchlists.map((watchlist) => {
            const { name, id, collectionCount, owner } = watchlist;
            const ownerText = isAddressEqual(owner.address, address) ? "You" : formatAddress(owner.address, 0, 4);
            return (
              <Flex
                key={id}
                gap={3}
                p={2}
                cursor="pointer"
                sx={{ _hover: { bg: "ui-01" } }}
                onClick={() => {
                  setSelectedWatchlist(watchlist);
                  onClose();
                }}
              >
                <WatchlistFavoritesIcon boxSize={8} />
                <Flex direction="column">
                  <WatchlistName name={name} owner={owner} />
                  <Text textStyle="helper" color="text-03">
                    {t("{{collectionCount}} collections | by {{ownerText}}", { collectionCount, ownerText })}
                  </Text>
                </Flex>
              </Flex>
            );
          })}
        </Stack>
      }
      arrowSize={0}
      gutter={10}
      contentProps={{
        p: 0,
        borderRadius: "xl",
        bg: "ui-bg",
        width: "100%",
        borderColor: "border-01",
        overflow: "hidden",
      }}
      arrowProps={{
        display: "none",
      }}
      closeOnBlur
      closeOnEsc
    >
      <IconButton size="xs" colorScheme="secondary" aria-label="select-watchlist-button" onClick={onToggle} {...props}>
        <Chevron direction="down" />
      </IconButton>
    </Popover>
  );
};
